/**
 * How the URL decides what the agent page renders.
 *
 * Pulled out of Agent.js so it can be tested without mounting a component that
 * fetches agent data, reads localStorage and starts timers. The rules are the
 * interesting part and they are pure: search string in, three booleans out.
 *
 * Audio is the default and avatar video is opt-in. Before this, audio_only
 * required ?audio_only=1 or ?plugin=1, so a plain visit to hevolve.ai fetched
 * avatar video before the visitor had decided they wanted to talk, while the
 * docs embed (which passes plugin=1) got the lighter path. The homepage was the
 * slowest way to meet the product.
 *
 * auto_guest stays opt-in on purpose. Defaulting it would guest-register every
 * visitor and begin consuming inference on arrival, which is a spend and abuse
 * decision, not a rendering one.
 */

/** @returns {{pluginMode: boolean, audioOnly: boolean, autoGuest: boolean}} */
export function agentUrlMode(search) {
  const q = new URLSearchParams(search || '');
  const pluginMode = q.get('plugin') === '1';
  // Two spellings for the same intent: ?video=1 reads naturally, and
  // ?audio_only=0 is the negation of the flag this replaced, so a link written
  // against the old behaviour still says what it meant.
  const wantsVideo = q.get('video') === '1' || q.get('audio_only') === '0';
  return {
    pluginMode,
    audioOnly: pluginMode || !wantsVideo,
    autoGuest: pluginMode || q.get('auto_guest') === '1',
  };
}

export default agentUrlMode;
